import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getFiltersAsync } from 'src/redux/async/vcn/vcn.async'

const initialState = {
  filtersLoader: false,
  filtersData: [],
  filtersError: '',
}

export const FilterSlice = createSlice({
  name: 'vcn-exposure/filters',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getFiltersAsync.pending), (state) => {
      state.filtersLoader = true
    })
    builder.addMatcher(isAnyOf(getFiltersAsync.fulfilled), (state, action) => {
      state.filtersLoader = false
      state.filtersData = action.payload
    })
    builder.addMatcher(isAnyOf(getFiltersAsync.rejected), (state, action) => {
      state.filtersLoader = false
      state.filtersError = action.payload.message
    })
  },
  reducers: {
    resetVCNFilterDetails: () => initialState
  },
})
export const { resetVCNFilterDetails } = FilterSlice.actions
export default FilterSlice.reducer
